"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = normalizeColor;

var _polished = require("polished");

function normalizeColor(color) {
  return (0, _polished.toColorString)((0, _polished.parseToRgb)(color));
}